export default __webpack_public_path__ + "static/media/footer-chatwithus-icon.9f254be0.svg";